import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Offline } from './offline.jsx';
import type { ContainerProps } from './types.js';
import { Viewer } from './viewer.jsx';

/** Viewer `<Container>` component. */
export const Container = ({
  children,
  className,
  deviceId,
  onGovernorState,
  onPresentedFrame,
  ...props
}: ContainerProps): ReactElement => {
  return (
    <div
      className={twMerge('relative rounded border border-base-100 bg-black', className)}
      {...props}
    >
      {deviceId ? (
        <>
          <Viewer
            className='rounded-inherit'
            deviceId={deviceId}
            onGovernorState={onGovernorState}
            onPresentedFrame={onPresentedFrame}
          />
          {children}
        </>
      ) : (
        // Observation props are Viewer-only. Offline spreads what it receives
        // onto a DOM node, where a function prop is an unknown attribute.
        <Offline className='rounded-inherit' />
      )}
    </div>
  );
};
